import React, { ChangeEvent, useEffect, useState } from 'react';
import { Form, FormControlProps } from 'react-bootstrap';

interface OwnProps extends Omit<FormControlProps, 'onChange' | 'value'> {
  onChange: (newValue: string) => void;
  value: string;
}

const PasswordInput = (props: OwnProps) => {
  const {onChange, value, onBlur, onKeyDown, ...restProps} = props;
  const [internalValue, setInternalValue] = useState<string>(value);

  useEffect(() => {
    if (value !== internalValue) {
      setInternalValue(value);
    }
  }, [value]);

  const internalOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInternalValue(event.target.value);
  };

  const internalOnBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    if (value !== internalValue) {
      onChange(internalValue);
    }

    if (onBlur) {
      onBlur(event)
    }
  }

  const internalOnKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (['Enter', 'Escape'].includes(event.key)) {
      onChange(internalValue);
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  }

  return (
    <Form.Control
      type='password'
      onChange={internalOnChange}
      value={internalValue}
      onBlur={internalOnBlur}
      onKeyDown={internalOnKeyDown}
      {...restProps}
    />
  );
};

export {
  PasswordInput,
};